﻿'use strict';

angular.module('ntmApp').factory('AttendanceReport', ['ForecastService', 'Constants', function (ForecastService, Constants) {

    function AttendanceReport() {

        var self = this;

        var defaultRoleSelected = 'All Roles';

        self.AllStatisticsFilteredByRoleType = 'All Statistics filtered by Role';
        self.SpecificStatisticsSplitByRoleType = 'Specific Statistic split by Role';

        self.reportTypes = [self.AllStatisticsFilteredByRoleType, self.SpecificStatisticsSplitByRoleType];
        self.selectedReportType = self.AllStatisticsFilteredByRoleType;

        self.statisticsTypes = [
            { id: 0, title: 'Total Available Hours', property: 'totalAvailable' },
            { id: 1, title: 'Total Overtime Hours', property: 'totalOvertime' },
            { id: 2, title: 'Staff Present', property: 'staffPresent' },
            { id: 3, title: 'Staff on Overtime', property: 'staffOnOvertime' }
        ];

        self.selectedStatisticsType = self.statisticsTypes[0];

        self.load = function (header, selectedWeek, scenarioId, forecastMode) {

            var data = {
                dateFrom: selectedWeek.startDate,
                dateTo: selectedWeek.endDate,
                forecastMode: forecastMode,
                forecastScope: header.selectedForecastScope.id.trim(),
                scenarioBreadcrumb: scenarioId,
                forecastView: header.forecastOptionsSummary.forecastView
            };

            self.loading = true;
            ForecastService.GetAttendanceReport(data).then(function (result) {

                if (result.success) {
                    self.rolesFilter = result.data.roleFilter;
                    self.dataSource = result.data.records;
                    self.daysRange = generateDateRange(self.dataSource);
                    self.loading = false;

                    if (!self.selectedRole) {
                        self.selectedRole = self.rolesFilter.firstOrDefault(function (role) {
                            return role.id === defaultRoleSelected;
                        });
                    }

                    self.recordsByStatistics = transformToAllStatisticsFilteredByRole(self.selectedRole, self.dataSource);
                    self.recordsForSpecificStatistics = transformToSpecificStatisticsForRoles(self.selectedStatisticsType, self.dataSource);
                }
            });
        };

        self.changeRole = function (role) {
            self.selectedRole = role;
            self.recordsByStatistics = transformToAllStatisticsFilteredByRole(self.selectedRole, self.dataSource);
        };

        self.changeStatisticsType = function (type) {
            self.selectedStatisticsType = type;
            self.recordsForSpecificStatistics = transformToSpecificStatisticsForRoles(self.selectedStatisticsType, self.dataSource);
        };

        self.getGridTitle = function () {

            switch (self.selectedReportType) {
                case self.AllStatisticsFilteredByRoleType: {
                    return defaultRoleSelected === self.selectedRole.value ? 'All Statistics for All Roles' : 'All Statistics for ' + self.selectedRole.value;
                }
                case self.SpecificStatisticsSplitByRoleType: {
                    return self.selectedStatisticsType.title + ' split by Role';
                }
                default: {
                    return '';
                }
            }
        };

        function generateDateRange(reportRecords) {

            var daysRange = [];

            if (reportRecords) {
                reportRecords.forEach(function (record) {

                    if (record.items) {
                        record.items.forEach(function (item) {
                            if (!daysRange.some(function (dow) {
                                    return dow.date.diff(moment(item.date), 'days') === 0;
                            })) {

                                var current = moment(item.date);
                                var dayLabel = Constants.DayLabels.getLabel(current).toUpperCase();
                                var month = current.format('M');
                                var day = current.format('D');

                                daysRange.push({
                                    date: current,
                                    label: '{0}: {1}/{2}'.format(dayLabel, month, day)
                                });
                            }
                        });
                    }
                });
            }

            return daysRange;
        }

        function transformToSpecificStatisticsForRoles(statisticsType, records) {
            var result = {
                records: []
            };

            self.rolesFilter.filter(function (role) {
                return role.id !== defaultRoleSelected;
            }).forEach(function (role) {

                var record = {
                    role: role.id,
                    items: []
                };

                var filteredByRole = records.filter(function (record) {
                    return record.role === role.id;
                });

                if (filteredByRole && filteredByRole.length > 0) {

                    self.daysRange.forEach(function (dow) {
                        var sum = 0;

                        filteredByRole.forEach(function (filteredRecord) {
                            var item = findItemByDate(filteredRecord, dow.date);
                            sum += item ? item[statisticsType.property] : 0;
                        });

                        record.items.push({
                            date: dow.date,
                            value: sum
                        });

                    });

                } else {
                    self.daysRange.forEach(function (dow) {
                        record.items.push({
                            date: dow.date,
                            value: 0
                        });
                    });
                }

                result.records.push(record);

            });

            result.grandTotalRow = generateGrandTotalRow(result.records);
            return result;
        }

        function generateGrandTotalRow(records) {

            var grandTotalRecord = {
                title: 'Grand Total',
                items: []
            };

            self.daysRange.forEach(function (dow) {
                var sum = 0;

                records.forEach(function (filteredRecord) {
                    var item = findItemByDate(filteredRecord, dow.date);
                    sum += item ? item.value : 0;
                });

                grandTotalRecord.items.push({
                    date: dow.date,
                    value: sum
                });
            });

            return grandTotalRecord;
        }

        function transformToAllStatisticsFilteredByRole(role, records) {

            var result = [];

            var recordsFilteredByRole = defaultRoleSelected === role.id ? records : records.filter(function (record) {
                return record.role === role.id;
            });

            self.statisticsTypes.forEach(function (type) {

                var record = {
                    title: type.title,
                    type: type.id,
                    items: []
                };

                self.daysRange.forEach(function (dow) {

                    var sum = 0;

                    recordsFilteredByRole.forEach(function (filteredRecord) {
                        var item = findItemByDate(filteredRecord, dow.date);
                        sum += item ? item[type.property] : 0;
                    });

                    record.items.push({
                        date: dow.date,
                        value: sum
                    });

                });

                result.push(record);

            });

            return fillEmptyStatistics(result);
        }

        function fillEmptyStatistics(records) {
            self.statisticsTypes.forEach(function (type) {

                var record = records.firstOrDefault(function (record) {
                    return record.type === type.id;
                });

                if (!record) {
                    var emptyRecord = {
                        title: type.title,
                        type: type.id,
                        items: []
                    };

                    self.daysRange.forEach(function (dow) {
                        emptyRecord.items.push({
                            date: dow.date,
                            value: 0
                        });
                    });

                    records.push(emptyRecord);
                }

            });

            return records;
        }

        function findItemByDate(record, date) {

            return record.items.firstOrDefault(function (item) {
                var itemDate = moment(item.date);
                return itemDate.diff(date, 'days') === 0;
            });
        }
    }

    return (AttendanceReport);
}]);